// Washing endpoints, split out of the grandfathered `apiRoutes.ts` so this
// ticket's three new routes do not grow that file (it is exempt from
// `max-lines`, not allowed to keep expanding). `apiRoutes` spreads this object,
// so consumers keep importing `apiRoutes.getWashRuleConfigurations` etc.
//
// `as const` is required: without it `method` widens to `string` and the
// `satisfies Record<string, RouteDefinition>` check in `apiRoutes.ts` fails.
export const washingRoutes = {
  // The washing api slice sends this url through axios with a baseURL that
  // already ends in `/`, and the washing e2e fixtures intercept the resulting
  // request. Keep it relative (no leading slash) — it is the exact string the
  // endpoint used before the route was registered here.
  getWashCleaningList: {
    method: 'get',
    path: () => `Washing/cleaning-list`,
  },
  getWashNextDepartures: {
    method: 'get',
    path: () => `Washing/next-departures`,
  },
  getWashMonitoredDepots: {
    method: 'get',
    path: () => `Washing/monitored-depots`,
  },
  getWashHistory: {
    method: 'get',
    path: () => `Washing/history`,
  },
  getWashRuleConfigurations: {
    method: 'get',
    path: () => `/Washing/rule-configurations`,
  },
  updateWashRuleConfigurationById: {
    method: 'put',
    path: (id: number) => `/Washing/rule-configurations/${id}`,
  },
} as const;
